import React, { memo } from "react";
import style from "./RiskAssessment.module.scss";
import { Button } from "../../../primary";
import RiskAssessmentList from "./RiskAssessmentList";
import RiskAssessmentForm from "./RiskAssessmentForm";
import { VIEW } from "./constant/RiskAssessment.constant";
import { useRiskAssessment } from "./hooks/useRiskAssessment";
import RiskAssessmentDetailPanel from "./RiskAssessmentDetailPanel";

const RiskAssessment = () => {
  const {
    view,
    fields,
    formData,
    errors,
    score,
    assessmentName,
    selectedId,
    successMessage,
    showNameInput,
    pendingName,
    createRiskLoading,
    saveAssessmentLoading,
    emailLoading,
    detailLoading,
    riskLoading,
    riskAssessmentList,
    setPendingName,
    handleChipChange,
    handleCreate,
    handleCancelForm,
    onSubmit,
    handleOnSelect,
    handleEditRiskAssessment,
    handleSaveRiskAssessment,
    handleConfirmName,
    handleCancelName,
    handleEmailRiskAssessment,
  } = useRiskAssessment();

  return (
    <div className={style.page}>
      <div className={style.header}>
        <h1 className={style.title}>Risk Assessment</h1>
        <Button className={style.newButton} onClick={handleCreate} type="button">
          + Risk Assessment
        </Button>
      </div>

      <div className={style.workspace}>
        <div className={style.leftPanel}>
          <RiskAssessmentList onSelect={handleOnSelect} selectedId={selectedId} assessments={riskAssessmentList} loading={riskLoading} />
        </div>

        <div className={style.rightPanel}>
          {view === VIEW.DETAIL && (
            <RiskAssessmentDetailPanel
              assessmentName={assessmentName}
              fields={fields}
              formData={formData}
              score={score}
              loading={detailLoading}
              onEdit={handleEditRiskAssessment}
              successMessage={successMessage}
              showNameInput={showNameInput}
              pendingName={pendingName}
              setPendingName={setPendingName}
              saveAssessmentLoading={saveAssessmentLoading}
              emailLoading={emailLoading}
              handleCancelName={handleCancelName}
              handleConfirmName={handleConfirmName}
              handleEmailRiskAssessment={handleEmailRiskAssessment}
              handleSaveRiskAssessment={handleSaveRiskAssessment}
            />
          )}

          {view === VIEW.FORM && (
            <RiskAssessmentForm
              mode={selectedId ? "edit" : "create"}
              assessmentName={assessmentName}
              fields={fields}
              formData={formData}
              errors={errors}
              onChipChange={handleChipChange}
              onCancel={handleCancelForm}
              onSubmit={onSubmit}
              loading={createRiskLoading}
              riskLoading={riskLoading}
              detailLoading={detailLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(RiskAssessment);
